module.exports = __webpack_public_path__ + "img/portrait.37c549dd.jpg";